import { Draw, Nullable } from '@Models';

export class DrawRoundView {
  displayDraw: boolean;
  displayMyDraw: boolean;
  displayResponse: boolean;
  displayMyResponse: boolean;
  myTeamId: string;
  myDraw: Nullable<Draw>;
  opponentDraw: Nullable<Draw>;
  action: DrawRoundActionView;

  constructor(params: DrawRoundViewParams) {
    this.displayDraw = params.displayMyDraw;
    this.displayMyDraw = params.displayMyDraw;
    this.displayResponse = params.displayResponse;
    this.displayMyResponse = params.displayMyResponse;
    this.myTeamId = params.myTeamId;
    this.myDraw = params.myDraw;
    this.opponentDraw = params.opponentDraw;
    this.action = params.action;
  }
}

export type DrawRoundViewParams = {
  displayDraw: boolean;
  displayMyDraw: boolean;
  displayResponse: boolean;
  displayMyResponse: boolean;
  myTeamId: string;
  myDraw: Nullable<Draw>;
  opponentDraw: Nullable<Draw>;
  action: DrawRoundActionView;
};

export class DrawRoundActionView {
  myArmy: boolean;
  myResponse: boolean;
  mySelection: boolean;

  constructor(params: DrawRoundActionViewParams) {
    this.myArmy = params.myArmy;
    this.myResponse = params.myResponse;
    this.mySelection = params.mySelection;
  }
}
export type DrawRoundActionViewParams = {
  myArmy: boolean;
  myResponse: boolean;
  mySelection: boolean;
};
